var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._g({directives:[{name:"model",rawName:"v-model",value:(_vm.formatted),expression:"formatted"}],staticClass:"simple-number-view",attrs:{"type":"text"},domProps:{"value":(_vm.formatted)},on:{"input":function($event){if($event.target.composing)return;_vm.formatted=$event.target.value}}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }